export default __webpack_public_path__ + "static/memberships-race-day-icon-099760e0f2aa3be4084714fa76277d9d.svg";